export const dataStatus = [
  { value: 'ON_PROCESS', label: 'Sedang Diproses' },
  { value: 'PENDING', label: 'Perlu Proses' },
  { value: 'APPROVED', label: 'Disetujui' },
  { value: 'REJECTED', label: 'Ditolak' },
];

export const dataWave = [
  { value: '', label: 'Semua Wave' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
];
